import React from 'react'
import Button from '../../forms/blackfillButton'
import { Link } from 'react-router-dom'

const BgimageTestRight = ({Image,H1,H2,P,BURL,BText}) => {
    const Style = {
        backgroundImage:`url(${Image})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top center'
    }
  return (
    <div style={Style}>
      <div className='bgimageTextLeft_container' style={{marginLeft:"60%", padding:"150px 0px"}}>
        <h2 style={{color:"white"}}>{H1}</h2>
        <h2 style={{color:"white"}}>{H2}</h2>
        <p style={{color:"white"}}>{P}</p>
        <div className='bgimageTextLeft_button_container'>
          <Link to={BURL}>
            <Button  Value={BText}  Type = 'button' Class='button_dark' />
          </Link>
        </div>
      </div>
    </div>
  )
}

export default BgimageTestRight
